<app-bell-plus [ngClass]="{'bell-disabled':proposta.possuiSosInversoEmAberto === 'S', 'bell-enabled':proposta.possuiSosInversoEmAberto !== 'S' }" class="" (onClick)="abrirModalSOS()"></app-bell-plus>

<app-modal #modalSosInverso title="ENVIO DE SOS" labelOk="ENVIAR SOS" labelClose="Cancelar" [ignoreBackdropClick]="true" [keyboard]="false" [disabledOk]="!isCamposPreenchidos()">
    <div class="modal-sos-inverso forms">
        <h2>MOTIVO</h2>
        <app-select-motivo [motivos]="motivos" (motivoChange)="sosInverso.idMotivoSos = $event"></app-select-motivo>

        <h2>OBSERVAÇÃO</h2>
        <div class="textarea-observacoes">
            <textarea [(ngModel)]="sosInverso.observacaoSos" class="form-control" maxlength="500" rows="10" cols="50" placeholder="Inserir observações" name="observacao" required></textarea>
        </div>
    </div>
</app-modal>

<app-modal-loader #modalLoader></app-modal-loader>

<app-modal-message [hideClose]="true" #modalMessage title="Atenção"></app-modal-message>
